import React from 'react'
import Main from './Main'

function Home() {
  return (
    <Main></Main>
  )
}

export default Home